import SubmitApplications from 'components/global/SubmitApplications';

const VCSubmitApplications = () => <SubmitApplications />;

export default VCSubmitApplications;
